import React from 'react';
import { LightbulbIcon } from 'lucide-react';
import { TopBanner } from '../components/TopBanner';
import { ParticipantTestimonials } from '../components/ParticipantTestimonials';
import { ExpertProfile } from '../components/ExpertProfile';
import { WebinarTimeline } from '../components/WebinarTimeline';
import { WebinarDetailsCard } from '../components/WebinarDetailsCard';
import { BonusSection } from '../components/BonusSection';
import { TrustpilotReviews } from '../components/TrustpilotReviews';
import { WhyDifferent } from '../components/WhyDifferent';
import { FAQSections } from '../components/FAQSections';
import { TransformationSummary } from '../components/TransformationSummary';
import { FinalCTA } from '../components/FinalCTA';
import { ChatTestimonials } from '../components/ChatTestimonials';
import { NewFooter } from '../components/NewFooter';
import { StickyBar } from '../components/StickyBar';
import { RegistrationProvider, useRegistration } from '../components/RegistrationContext';
const Adv2bContent = () => {
  const {
    openPopup
  } = useRegistration();
  return <>
      <div className="advertorial-content max-w-3xl mx-auto px-4 font-sans text-gray-800 pb-28" data-id="element-594" data-mp="bwouat5846wi">
        <TopBanner data-id="element-595" data-mp="3td6ou2oy7iqg" />

        {/* 1. HOOFDTITEL (Hero sectie aangepast) */}
        <section className="mb-10 text-center" data-id="element-596" data-mp="3tau6vpj6x8de">
          <h1 className="text-[1.6rem] md:text-3xl font-bold text-[rgb(30,64,175)] mb-6 text-center leading-snug" data-id="element-597" data-mp="25c4e72zjqt4">
            De #1 Fout Die Liefdevolle Baasjes Maken Waardoor Hun Hond Onzeker Blijft
          </h1>
          <p className="text-blue-600 font-semibold mb-8 text-center" data-id="element-598" data-mp="3of56jjzcjng1">
            Modern onderzoek naar honden laat zien dat we op een andere manier
            met hen om moeten gaan.
          </p>
          <div className="w-full mb-2" data-id="element-599" data-mp="3fdfdyatqaigo">
            <img src="https://cdn.magicpatterns.com/uploads/tHBtiTWsnB2LRi2ECefzib/Ontwerp_zonder_titel_(18).jpg" alt="Hond die zich vastklampt aan zijn baasje tegen een betonnen muur" className="w-full h-auto rounded-lg" data-id="element-600" data-mp="18mfxdgrkz2dx" />
          </div>
          <p className="text-xs text-gray-400 italic mb-6" data-id="element-601" data-mp="175a9rddrfxjn">
            Soms kan anderhalf uur alles veranderen in de relatie met je hond
          </p>
          <div className="w-full h-[1px] bg-gray-200" data-id="element-602" data-mp="126z135z7bt30"></div>
        </section>

        {/* 2. EERSTE TEKSTBLOK (Vervangt LisaStory) */}
        <section className="mb-12" data-id="element-603" data-mp="x9h0c2vc8k63">
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-604" data-mp="1uv4ltsq99i2u">
            Je hond springt op als er bezoek komt. Of hij blaft aan één stuk
            door. Of hij trekt zo hard aan de lijn dat wandelen geen plezier
            meer is. Je hebt het al tientallen keren gecorrigeerd. Je bent
            strenger geworden. Je hebt je stem verheven. Misschien heb je hem
            zelfs bestraft.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-605" data-mp="2dme872l4k1bu">
            En toch gebeurt het steeds weer.
          </p>
          <p className="mb-8 text-gray-800 leading-relaxed" data-id="element-606" data-mp="28t2zevwr5aha">
            Wat de meeste baasjes op dat moment denken: mijn hond wil gewoon
            niet luisteren. Maar volgens gediplomeerd hondengedragsconsultant
            Amee de Bruijn is wat er in werkelijkheid aan de hand is, iets heel
            anders.
          </p>
          <div className="w-full mb-6" data-id="element-607" data-mp="2q6b7tfa1ccu2">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3JyaDPTDobRjD5WRihmtQh/Scherm%C2%ADafbeelding_2025-08-15_om_15.32.12.png" alt="Innig moment tussen een man en zijn golden retriever die elkaar aandachtig aankijken" className="w-full h-auto rounded-lg" data-id="element-608" data-mp="2v3bcpmv5f9jl" />
            <p className="text-xs text-gray-500 mt-2 text-center italic" data-id="element-609" data-mp="38uzn9lpr1pyg">
              Het moment waarop je eindelijk begrijpt wat je hond al die tijd
              probeerde te zeggen
            </p>
          </div>
        </section>

        {/* 3. TWEEDE TEKSTBLOK (Vervangt BreakthroughMoment) */}
        <section className="mb-12" data-id="element-610" data-mp="3ns8hcn6ft7tv">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-611" data-mp="odpvo8hnubjf">
            Je praat heel de dag met lichamelijke signalen
          </h2>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-612" data-mp="jdlgclshnmus">
            "Honden communiceren primair via lichaamstaal," legt Amee uit.
            "Blaffen en piepen zijn eigenlijk al de laatste uitingen - het punt
            waarop een hond niet meer weet hoe hij het anders moet zeggen."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-613" data-mp="5fn2dhi2xsft">
            De echte communicatie zit volgens haar in veel subtielere signalen.
            Een hond die gaapte toen je hem aanraakte. Een hond die zijn gewicht
            verplaatste toen je dichter bij hem kwam. Een hond die even wegkeek
            op het moment dat de spanning opliep. Geen toevallige bewegingen,
            zegt Amee - boodschappen.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-614" data-mp="1pwrzcfi8krkb">
            Maar de meeste baasjes weten niet wat ze betekenen. "Niet omdat ze
            het niet willen weten," benadrukt ze, "maar omdat niemand het ze
            ooit heeft geleerd. Je wordt niet geboren met kennis van hondentaal.
            En in de meeste traditionele hondentrainingen staat het ook niet
            centraal."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-615" data-mp="1jgt8rdmr9e44">
            Het gevolg is dat baasjes de hele aanloop missen. Ze zien niet wat
            er opbouwt. Ze zien alleen het eindpunt - het blaffen, het springen,
            het uitvallen - en dát is het moment waarop ze ingrijpen. Met een
            correctie. Met straf.
          </p>
          <p className="mb-6 text-gray-800 leading-relaxed font-semibold" data-id="element-616" data-mp="22c9mbhpakbef">
            "Maar tegen de tijd dat een hond zover is," zegt Amee, "heeft hij al
            lang geprobeerd iets te zeggen. En niemand heeft geluisterd."
          </p>
        </section>

        {/* 4. DERDE TEKSTBLOK */}
        <section className="mb-12" data-id="element-617" data-mp="2ztqeo7szel78">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-618" data-mp="2zurragpnbfr2">
            Je stem zegt: Stop daarmee. Maar je lichaam zegt: ik keur dit goed.
          </h2>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-619" data-mp="34qnfb383pj3c">
            Voor veel baasjes is dit het moment waarop alles op zijn plaats
            valt. Want het probleem is niet alleen dat baasjes hondentaal niet
            begrijpen - het probleem is ook dat baasjes zelf voortdurend
            signalen afgeven waar ze zich niet bewust van zijn.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-620" data-mp="2lzcrww1l3og7">
            Amee legt tijdens haar webinar{' '}
            <a href="/webinar-mc-adv2" onClick={e => {
            e.preventDefault();
            openPopup();
          }} className="text-blue-700 underline font-semibold cursor-pointer hover:text-blue-900" data-id="element-621" data-mp="2gzi0mrdwcwum">
              (klik hier om beschikbaarheid te zien)
            </a>{' '}
            een veelvoorkomende situatie uit: je hond springt op. Jij wordt
            boos. Je verheft je stem, je zegt streng "nee" of "af". Maar
            tegelijkertijd zeg je met je lichaam dat je zijn gedrag goedkeurt.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed italic font-semibold" data-id="element-622" data-mp="sgnaz4lxuqu4">
            "Jouw stem zegt: stop daarmee. Jouw lichaam zegt: ik keur dit goed."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-623" data-mp="wfmovepndxxp">
            En honden kijken meer naar lichaamstaal dan naar stemgeluid. "Dus
            wat denk je welk signaal er aankomt?" vraagt Amee.
          </p>
          <p className="mb-6 text-gray-800 leading-relaxed" data-id="element-624" data-mp="8smwgoocdu6v">
            Dit is slechts één voorbeeld. Amee beschrijft tientallen situaties
            per dag waarin hetzelfde gebeurt - waarin de bedoeling van de
            eigenaar en zijn lichaamstaal elkaar tegenspreken. En elke keer
            raakt de hond een stukje meer verward.
          </p>
        </section>

        {/* 5. VIERDE TEKSTBLOK */}
        <section className="mb-12" data-id="element-625" data-mp="2akcbfjx7hv49">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-626" data-mp="2alnhxri1dgz2">
            De oplossing is eenvoudiger dan je denkt
          </h2>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-627" data-mp="25o5euhqp9vyz">
            "Hondentaal is geen mysterie," stelt Amee. "Het is een consistent
            systeem van signalen dat te leren is."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-628" data-mp="2fmbf6uwuyu1q">
            En zodra je het kent, gebeuren er volgens haar twee dingen tegelijk.
            Je begrijpt eindelijk wat je hond al die tijd probeerde te
            vertellen. En je leert hoe je zelf bewuster communiceert - met je
            lichaam, niet alleen met je stem.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed italic font-semibold" data-id="element-629" data-mp="2ybhu06uj71i9">
            "Dat is het moment waarop het gedrag verandert. Niet omdat de hond
            anders wordt, maar omdat de communicatie eindelijk klopt."
          </p>
          <p className="mb-6 text-gray-800 leading-relaxed" data-id="element-630" data-mp="386t7klu7e2of">
            De verwarring verdwijnt. En daarmee verdwijnt ook het gedrag dat
            zoveel frustratie veroorzaakte.
          </p>
        </section>

        {/* 6. SECTIE MET HET GEKLEURDE KADER */}
        <section className="mb-12" data-id="element-631" data-mp="3hvqdzqc2qnp1">
          <div className="bg-blue-50 border-l-4 border-blue-700 rounded-r-lg p-8" data-id="element-632" data-mp="3hyl0roik8klm">
            <div className="flex items-center gap-3 mb-6" data-id="element-633" data-mp="3mxfpf737l3dn">
              <LightbulbIcon className="w-6 h-6 text-blue-700" data-id="element-634" data-mp="385dum1fzx0kh" />
              <h2 className="text-2xl font-bold text-blue-900" data-id="element-635" data-mp="3cwvl1vke7ir7">
                Leer hondentaal in 90 minuten - gratis
              </h2>
            </div>

            <p className="mb-4 text-gray-800 leading-relaxed text-lg" data-id="element-636" data-mp="2z7bkmweaaxl2">
              Amee de Bruijn deelt deze kennis in{' '}
              <a href="/webinar-mc-adv2" onClick={e => {
              e.preventDefault();
              openPopup();
            }} className="text-blue-700 underline font-semibold cursor-pointer hover:text-blue-900" data-id="element-637" data-mp="334zjgaj3lai8">
                een gratis webinar van 90 minuten
              </a>{' '}
              voor hondeneigenaren die vastlopen met hun hond. Je leert welke
              signalen je hond gebruikt en wat ze betekenen. Je leert hoe je die
              signalen eerder herkent - voordat gedrag escaleert. En je leert
              hoe je je eigen lichaamstaal bewust inzet, zodat jouw boodschap
              ook daadwerkelijk aankomt.
            </p>

            <p className="text-blue-800 leading-relaxed text-lg font-semibold mb-4" data-id="element-638" data-mp="10ezagkal74bg">
              Meer dan 100.000 Nederlandse en Vlaamse hondeneigenaren volgden
              het webinar al. Veel van hen zeiden achteraf hetzelfde: het was
              alsof er eindelijk ondertiteling werd aangezet.
            </p>

            <p className="text-gray-800 leading-relaxed text-lg mb-6" data-id="element-639" data-mp="1edp8q3957a1e">
              Meld je gratis aan. Eén webinar van 90 minuten kan veranderen hoe
              jij en je hond de rest van jullie leven met elkaar communiceren.
            </p>

            <button onClick={openPopup} className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold py-4 px-8 rounded-lg text-lg transition-colors duration-200 shadow-lg" data-id="element-640" data-mp="2ywj734swladf">
              Bekijk webinar van Amee →
            </button>
          </div>

          <div className="w-full mt-6 mb-6" data-id="element-641" data-mp="2kwqndtfsnuey">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mPezTbx7aSGaxHbt8eLB8F/Scherm%C2%ADafbeelding_2025-08-15_om_15.37.25.png" alt="Vrouw in oranje trui communiceert met haar border collie in een park" className="w-full h-auto rounded-lg" data-id="element-642" data-mp="2kxjl64wrz9ky" />
            <p className="text-xs text-gray-500 mt-2 text-center italic" data-id="element-643" data-mp="2owsfbavq99h1">
              "In 90 minuten kan ik mensen de basisgrammatica van de hondentaal
              leren," stelt Amee
            </p>
          </div>
        </section>

        {/* AL HET ANDERE (Blijft exact hetzelfde) */}
        <ParticipantTestimonials data-id="element-644" data-mp="2xzb3pa8w3di6" />

        {/* Wat is een webinar? (inline, vervangt Science component) */}
        <section className="mb-12" data-id="element-645" data-mp="32xmdjkz6po0e">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-646" data-mp="370ral80hwxhn">
            Wat is een webinar?
          </h2>
          <p className="text-gray-800 leading-relaxed" data-id="element-647" data-mp="3c0dprmzvwnt3">
            Een webinar is een online presentatie die je live kunt volgen vanaf
            je telefoon, tablet of computer. Je hoeft nergens naartoe te reizen
            - je volgt gewoon thuis, op kantoor of onderweg via een
            internetverbinding. Tijdens het webinar kun je via de chat vragen
            stellen aan Amee, en na afloop ontvang je automatisch de opname
            zodat je alles terug kunt kijken wanneer het jou uitkomt.
          </p>
        </section>

        <ExpertProfile data-id="element-648" data-mp="1vl2pkm6sy8jh" />
        <WebinarTimeline data-id="element-649" data-mp="1vjj7qr5hzpfl" />
        <WebinarDetailsCard data-id="element-650" data-mp="20kfct81l5hml" />
        <BonusSection data-id="element-651" data-mp="20jngfv05zfv9" />
        <TrustpilotReviews data-id="element-652" data-mp="20ivu7asgiuhn" />
        <WhyDifferent data-id="element-653" data-mp="1t160p71p34tu" />
        <FAQSections data-id="element-654" data-mp="1t1pjepz65x8x" />
        <TransformationSummary data-id="element-655" data-mp="1szuxp9g2q13s" />
        <FinalCTA data-id="element-656" data-mp="1sz3buqca3hqp" />
        <ChatTestimonials data-id="element-657" data-mp="1o235sfffiezl" />
        <NewFooter data-id="element-658" data-mp="1o1tgyv64edvh" />
      </div>
      <StickyBar data-id="element-659" data-mp="1o2md727gdkzd" />
    </>;
};
export const Adv2bPage = () => {
  return <RegistrationProvider data-id="element-660" data-mp="1j1yowoalzi8u">
      <Adv2bContent data-id="element-661" data-mp="1j16sjb96tghi" />
    </RegistrationProvider>;
};